import React, { useRef, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { fetchTripsByCategory } from '../../functions/FetchTrips'; // Use fetchTripsByCategory
import '../../styles/homeCategories.css'; // Import the CSS file
import { db } from '../../firebase';
import { doc, getDoc } from 'firebase/firestore';

const LadakhBikeTrips = () => {
  const cardsContainerRef = useRef(null);
  const [isMobile, setIsMobile] = useState(false);
  const [bikeTrips, setBikeTrips] = useState([]); // State for bike trips
  const [bannerImage, setBannerImage] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    const checkIfMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    checkIfMobile();
    window.addEventListener('resize', checkIfMobile);

    return () => window.removeEventListener('resize', checkIfMobile);
  }, []);

  useEffect(() => {
    const fetchBikeTrips = async () => {
      const trips = await fetchTripsByCategory('ladakh bike trip');
      setBikeTrips(trips);
    };
    fetchBikeTrips();
  }, []);

  // Fetch Ladakh Bike Trips banner image from Firestore
  useEffect(() => {
    async function fetchBannerImage() {
      try {
        const docRef = doc(db, "Images", "AllImages");
        const docSnap = await getDoc(docRef);
        if (docSnap.exists() && docSnap.data()["Ladakh Bike Trips"] && docSnap.data()["Ladakh Bike Trips"].url) {
          setBannerImage(docSnap.data()["Ladakh Bike Trips"].url);
        }
      } catch (error) {
        // fallback: do nothing
      }
    }
    fetchBannerImage();
  }, []);

  const scrollLeft = () => {
    if (cardsContainerRef.current) {
      cardsContainerRef.current.scrollLeft -= 250;
    }
  };

  const scrollRight = () => {
    if (cardsContainerRef.current) {
      cardsContainerRef.current.scrollLeft += 250;
    }
  };

  const handleCardClick = (tripId) => {
    window.scrollTo(0, 0);
    navigate(`/itinerary/${tripId}`);
  };

  return (
    // Add specific class for margin override
    <div className="category-outer-container ladakh-trips-outer">
      <div className="category-container">
        <div
          className="category-banner"
          style={{
            backgroundImage: bannerImage
              ? `url('${bannerImage}')`
              : "url('https://thedreamridersgroup.com/listing/9/Explore%20Ladakh%20on%20two%20wheels,Morey%20Plains.jpg')"
          }}
        >
          <div className="category-banner-content">
            <h1 className="category-banner-h1" style={{ fontSize: isMobile ? '1.8em' : '2.5em' }}>Ladakh Bike Trips</h1>
            <p className="category-banner-p">Experience the thrill of biking through stunning Himalayan landscapes</p>
            <button
              type="button"
              className="category-explore-button"
              style={{ backgroundColor: '#ffeb3b', color: '#111' }}
              onClick={() => {
                navigate('/destinations?location=ladakh bike trip');
                window.scrollTo(0, 0);
              }}
            >
              Explore
            </button>
          </div>
        </div>
      </div>

      <button
        className="nav-arrow nav-left"
        onClick={scrollLeft}
        aria-label="Scroll left"
      >
        <span className="arrow-icon" style={{ backgroundColor: '#ffeb3b' }}>
          <i className="fas fa-chevron-left"></i>
        </span>
      </button>

      <button
        className="nav-arrow nav-right"
        onClick={scrollRight}
        aria-label="Scroll right"
      >
        <span className="arrow-icon" style={{ backgroundColor: '#ffeb3b' }}>
          <i className="fas fa-chevron-right"></i>
        </span>
      </button>

      <div className="category-cards-overlay" ref={cardsContainerRef}>
        {bikeTrips.map((destination, index) => (
          <div
            key={index}
            className="destination-card"
            onClick={() => handleCardClick(destination.id)}
            role="button"
            tabIndex={0}
          >
            <img 
              src={(destination.img || destination.cover_image_url) || null} 
              alt={destination.location || destination.name} 
              className="destination-card-img" 
            />
            <div className="card-info">
              <h3 className="card-info-h3">{destination.tripname || destination.location}</h3>
              {/* <p className="card-info-p">Starts From {destination.display_price}/-</p> */}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default LadakhBikeTrips;
